var _path, _path2, _g, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _polygon, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g3, _path17, _path18, _path19, _path20, _path21, _path22, _g4, _g5, _polygon2, _circle, _g6, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g7, _path31, _g8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIlluSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    enableBackground: "new 0 0 2000 2000",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.8375,
    y1: 1085.7239,
    x2: 1930.0837,
    y2: 1085.7239,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#11423F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#0E2A2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M102.6,1045.7l1219.7-700c30.8-17.8,68.7-17.8,99.5,0l458.5,264.8c66.3,38.3,66.3,134,0,172.3 l-1219.7,700c-30.8,17.8-68.7,17.8-99.5,0L102.6,1218C36.2,1179.7,36.3,1084,102.6,1045.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.66,
    y1: 856.4834,
    x2: 1929.9,
    y2: 856.4834,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M52.7,1228.9c0,33.5,16.6,67,49.7,86.2l450.7,260.3c35.7,20.6,79.6,20.6,115.3,0l1211.8-695.5 c33.2-19.2,49.8-52.7,49.8-86.2v-97.6c0,33.5-16.6,67-49.8,86.2L669,1477.5c-36,20.8-80.5,20.8-116.5,0l-450.1-259.9 c-33.2-19.2-49.8-52.7-49.7-86.2V1228.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#43FFBB",
    enableBackground: "new    ",
    points: "1218,881.8 1205.4,889 1146.3,854.9 1158.9,847.6  "
  }), /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    opacity: 0.75,
    enableBackground: "new    ",
    width: 910,
    height: 530,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA44AAAISCAYAAACDJJEYAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAALDpJREFUeNrs3c2WIzd2LtBTpJiU Wt1+M0/8oJ740exu/SVZXSUHqkCIiASDQWYCsfdaXLp2t+9AA6z4EvjOiQAAAAAAAABY6pN/BcCI /vPzf//lfPufT//12b8ZAADBERAYPxXn29d/psD4WYAEABAcAYHxU/HLfc5/AiQAgOAIbC807qZz bZf9PmWh8Zz9BEgAgEY/+FcADCLdMO6ns22fhcc8OJ6y358B8kvwFCABAARHYCPBcTeda4fplwLk pyw0vma/PECevwTIP/8/EiABAP76oQXQremZagqNKTAep9/LFB6//mefs+D4+5ffH9MvhciLZ6zC IwDAd24cgVGUT1W/hsYfp3+mW8fTFBZ/L355gPzzdtLzVQAAwREYMzTmt49fw2K6fTzE91vH1yko /lb8fp/+b/InrPqPAACCI7CBMJkC5A/xvev4NRy+ZL9DFiDz20f9RwCA+D5tEKBn+X7G1FM8xeXq jU9TePx6A/nTl9/PX37/yH5/n35/i/9/4pp3JL8N2clWfwAAbIYPIKB7X8JcWruRJqr+OIXDn6Yg +FN87zumm8c0LCd1Hr/eNv46/dLT1bL/eLED0u0jALAVnqoCI8hvG1MY3MX356r5f+dzfJ+0mv65 z0LnSxYe9R8BAARHYLDwmPqL5f/ulP2+/udpYM5+Co4vRXhMAVL/EQAgPFUFBlHsc0y3iT9kAfBr WPwx+6Xw+K2/GJe7HtPk1fz5arp9vBYg3T4CAIIjQEfhMV/Jkd8iHrMAecx+eYCM0H8EABAcgU2E x4jvt49lh/F4JUS+ZAEyTZxOT1/LAFn2H1OALCe5er4KAAiOAB0EyGvPV/MOY/6ENQ+Q++yMLJ+v /nYlRP6RBchzHiCFRwBAcAToI0DuZgLk8UqAbOk/1p6wer4KAAiOAB2GxygC5L4IkLf2H18r4TH9 8uE5p8jWgQiQAIDgCPCxA2T+2xcBsqX/mAJkWvNRDs8pn6/+ZX1H6D8CAIIjQFcB8tb+Y9r5uIu2 28fa9FX9RwBAcAToKEDe2n88xmX/Mb99tL4DABAcAQYMjxHt/cfyBjLdPkZcDs+ZW9+h/wgACI4A nQbIuf7jMdpuH8sAObe+Q/8RABAcAToPkOXz1Vr3sXV9h/4jACA4AgwYIMv+4yGWre8on6/qPwIA giPAIOEx4nr/sRyeU1vfkfqP59B/BAAER4ChA+TS9R2H0H8EAARHgM0GyH20re9Yo/94Cs9XAQDB EaCb8BjRvr5D/xEAEBwBNhwg59Z3PKL/mAKk56sAgOAI0GmAfFb/MQVI6zsAAMERoMMAuZsJkEv7 j7UnrJ6vAgCCI0CH4TFi3f7jayU8pp/1HQCA4AjQaYC8t/+YAuR5CoTl8BzrOwAAwRFgsAB5a//x ZQqPu2i7faxNX9V/BAAER4COAuSt/cdjXPYf89tH6zsAAMERYMDwGNHefyxvINPtY8Tl8Jy59R36 jwCA4AjQaYCc6z8eo+32sQyQc+s79B8BAMERoPMAWT5frXUfW9d3vNV/PIXnqwCA4AjQXYAs+4+H WLa+o3y+qv8IAAiOAIOEx4jr/cdyeE5tfUfqP56jrf+YAqTnqwCA4AjQWYBcur7jEMv6jylAWt8B AAiOAB0HyH20re9o6T/WnrB6vgoACI4AHYbHiPb1HS39x9dKeEw/6zsAAMERoNMAObe+o6X/mALk eQqE5fAc6zsAAMERYLAAeWv/8WUKj7tou32sTV/VfwQAwRGAjgLkbiZAXus/HuOy/5jfPlrfAQAI jgADhseI9v5jeQOZbh8jLofnzK3v0H8EAMERgE4D5Fz/8Rhtt49lgJxb36H/CACCIwCdB8jy+Wqt +9i6vkP/EQAQHAEGDJBl//EQy9Z3lM9X9R8BQHAEYJDwGHG9/1gOz6mt70j9x3PoPwIAgiPA0AFy 6fqOQ+g/AgCCI8BmA+Q+2tZ3rNF/PIXnqwAgOALQTXiMaF/fof8IAAiOABsOkHPrOx7Rf0wB0vNV ABAcAeg0QD6r/5gCpPUdACA4AtBhgNzNBMil/cfaE1bPVwFAcASgw/AYsW7/8bUSHtPP+g4AEBwB 6DRA3tt/TAHyPAXCcniO9R0AIDgCMFiAvLX/+DKFx1203T7Wpq/qPwKA4AhARwHy1v7jMS77j/nt o/UdACA4AjBgeIxo7z+WN5Dp9jHicnjO3PoO/UcAEBwB6DRAzvUfj9F2+1gGyLn1HfqPACA4AtB5 gCyfr9a6j63rO/QfAUBwBGDAAFn2Hw+xbH1H+XxV/xEABEcABgmPEdf7j+XwnNr6jtR/PIf+IwAI jgAMHSCXru84hP4jAAiOAGw2QO6jbX3HGv3HU3i+CgCCIwDdhMeI9vUd+o8AIDgCsOEAObe+4xH9 xxQgPV8FAMERgE4D5LP6jylAWt8BAIIjAB0GyN1MgFzaf6w9YfV8FQAERwA6DI8R6/YfXyvhMf2s 7wAAwRGATgPkvf3HFCDPUyAsh+dY3wEAgiMAgwXIW/uPL1N43EXb7WNt+qr+IwAIjgB0FCBv7T8e 47L/mN8+Wt8BAIIjAAOGx4j2/mN5A5luHyMuh+fMre/QfwQAwRGATgPkXP/xGG23j2WAnFvfof8I AIIjAJ0HyPL5aq372Lq+Q/8RAARHAAYMkGX/8RDL1neUz1f1HwFAcARgkPAYcb3/WA7Pqa3vSP3H c+g/AoDgCMDQAXLp+o5D6D8CgOAIwGYD5D7a1nes0X88heerAAiOANBNeIxoX9+h/wgAgiMAGw6Q c+s7HtF/TAHS81UABEcA6DRAPqv/mAKk9R0ACI4A0GGA3M0EyKX9x9oTVs9XARAcAaDD8Bixbv/x tRIe08/6DgAERwDoNEDe239MAfI8BcJyeI71HQAIjgAwWIC8tf/4MoXHXbTdPtamr+o/AiA4AkBH AfLW/uMxLvuP+e2j9R0ACI4AMGB4jGjvP5Y3kOn2MeJyeM7c+g79RwAERwDoNEDO9R+P0Xb7WAbI ufUd+o8ACI4A0HmALJ+v1rqPres73uo/nsLzVQAERwDoLkCW/cdDLFvfUT5f1X8EQHAEgEHCY8T1 /mM5PKe2viP1H8/R1n9MAdLzVQAERwDoLEAuXd9xiGX9xxQgre8AQHAEgI4D5D7a1ne09B9rT1g9 XwVAcASADsNjRPv6jpb+42slPKaf9R0ACI4A0GmAnFvf0dJ/TAHyPAXCcniO9R0ACI4AMFiAvLX/ +DKFx1203T7Wpq/qPwIgOAJARwFyNxMgr/Ufj3HZf8xvH63vAEBwBIABw2NEe/+xvIFMt48Rl8Nz 5tZ36D8CIDgCQKcBcq7/eIy228cyQM6t79B/BEBwBIDOA2T5fLXWfWxd36H/CIDgCAADBsiy/3iI Zes7yuer+o8ACI4AMEh4jLjefyyH59TWd6T+4zn0HwEQHAFg6AC5dH3HIfQfARAcAWCzAXIfbes7 1ug/nsLzVQAERwDoJjxGtK/v0H8EQHAEgA0HyLn1HY/oP6YA6fkqAIIjAHQaIJ/Vf0wB0voOAARH AOgwQO5mAuTS/mPtCavnqwAIjgDQYXiMWLf/+FoJj+lnfQcAgiMAdBog7+0/pgB5ngJhOTzH+g4A BEcAGCxA3tp/fJnC4y7abh9r01f1HwEQHAGgowB5a//xGJf9x/z20foOAARHABgwPEa09x/LG8h0 +xhxOTxnbn2H/iMAgiMAdBog5/qPx2i7fSwD5Nz6Dv1HAARHAOg8QJbPV2vdx9b1HfqPAAiOADBg gCz7j4dYtr6jfL6q/wiA4AgAg4THiOv9x3J4Tm19R+o/nkP/EQDBEQCGDpBL13ccQv8RAMERADYb IPfRtr5jjf7jKTxfBRAcAYBuwmNE+/oO/UcABEcA2HCAnFvf8Yj+YwqQnq8CCI4AQKcB8ln9xxQg re8AEBwBgA4D5G4mQC7tP9aesHq+CiA4AgAdhseIdfuPr5XwmH7WdwAIjgBApwHy3v5jCpDnKRCW w3Os7wAQHAGAwQLkrf3Hlyk87qLt9rE2fVX/EUBwBAA6CpC39h+Pcdl/zG8fre8AEBwBgAHDY0R7 /7G8gUy3jxGXw3Pm1nfoPwIIjgBApwFyrv94jLbbxzJAzq3v0H8EEBwBgM4DZPl8tdZ9bF3f8Vb/ 8RSerwIIjgBAdwGy7D8eYtn6jvL5qv4jgOAIAAwSHiOu9x/L4Tm19R2p/3iOtv5jCpCerwIIjgBA ZwFy6fqOQyzrP6YAaX0HgOAIAHQcIPfRtr6jpf9Ye8Lq+SqA4AgAdBgeI9rXd7T0H18r4TH9rO8A EBwBgE4D5Nz6jpb+YwqQ5ykQlsNzrO8AEBwBgMEC5K39x5cpPO6i7faxNn1V/xFAcAQAOgqQu5kA ea3/eIzL/mN++2h9B4DgCAAMGB4j2vuP5Q1kun2MuByeM7e+Q/8RQHAEADoNkHP9x2O03T6WAXJu fYf+I4DgCAB0HiDL56u17mPr+g79RwDBEQAYMECW/cdDLFvfUT5f1X8EEBwBgEHCY8T1/mM5PKe2 viP1H8+h/wggOAIAQwfIpes7DqH/CCA4AgCbDZD7aFvfsUb/8RSerwIIjgBAN+Exon19h/4jgOAI AGw4QM6t73hE/zEFSM9XAQRHAKDTAPms/mMKkNZ3AAiOAECHAXI3EyCX9h9rT1g9XwUQHAGADsNj xLr9x9dKeEw/6zsABEcAoNMAeW//MQXI8xQIy+E51ncACI4AwGAB8tb+48sUHnfRdvtYm76q/wgI jgAAHQXIW/uPx7jsP+a3j9Z3AAiOAMCA4TGivf9Y3kCm28eIy+E5c+s79B8BwREAoNMAOdd/PEbb 7WMZIOfWd+g/AoIjAEDnAbJ8vlrrPrau79B/BARH/woAgAEDZNl/PMSy9R3l81X9R0BwBAAYJDxG XO8/lsNzaus7Uv/xHPqPAIIjADB0gFy6vuMQ+o8AgiMAsNkAuY+29R1r9B9P4fkqIDgCAHQTHiPa 13foPwIIjgDAhgPk3PqOR/QfU4D0fBUQHAEAOg2Qz+o/pgBpfQcwZnDMnnd845ADAAYKkLuZALm0 /1h7wur5KjBWcCz6AJEdjIlnFgDACOExYt3+42slPKaf9R3AGMHxSgeg/O9+Ln4CJADQe4C8t/+Y AuR5CoTl8BzrO4BxguN0cO7ir083PhWh8RyeWQAA4wbIW/uPL1N43EXb7WNt+qr+I/Cxg2Px1n9f /FJ4TKHxlP0ESABgxAB5a//xGJf9x/z20foOYKjgmL/tP2S/a39Bew1jpgGAccNjRHv/sbyBTN9O EZfDc+bWd+g/Ah87OBZ/WSsPw3z8dEzhMB186a9kxkwDAKMGyLn+4zHabh/LADm3vkP/EfjwwTEd hC/TwffT9EuH364IjvlfyYyZBgC2ECDL56u17mPr+g79R6DL4Jje7n8NjH/78vt5+n+nZxcxHWK1 pxaeWQAAowfIsv+Y6j23ru8on6/qPwLdBMf07OKnKTT+PAXIH6dDL906pvBozDQAsLXwGHG9/1gO z6mt70j9x/RNpf8IfPzgOB2C+V/NyhvHdOuYnqympxa1v5J5ZgEAbCFALl3fkeZH6D8C3QXHa8Nx UnhMv/RkNQ+PxkwDAALk5VqzlvUda/QfT76rgPcIjvm0sJcsPOa/dNjlzyyMmQYAth4eI9rXd+g/ An0Gx+zQK5+spgmrP2bB8cfwzAIA4Nq31Nz6jkf0H+3VBp4bHIvwmA66a1PC1n5mof8IAIwaIJ/V f7RXG3h6cIy4/syifKPvmQUAwNsBcjcTIJf2H2vfVr6rgMcHx5mDzphpAIBl4TFi3f7jayU82qsN PDc4FuHRmGkAgPsD5L39xxQgz/F9sn0eHn1XAc8PjjMB0phpAID7A+Stf5h/mb6rdtF2+2iuBPC8 4JgdchHGTAMArBkgb+0/HuPyD/P57aPvKuB9g+OVQ86YaQCA+8NjRPsf5ssbyH3Yqw18xOBYCZDG TAMArPNdde0P88dou3285btK/xF4fHC8ctAZMw0AsF6ALL+ran+UN1cC+PjBMTvkIoyZBgBYM0CW f5g/hLkSQK/B8cohZ8w0AMD931URz92rba4E8PjgWAmQxkwDALzPd5W5EsDHDY5XDjpjpgEA1g2Q a+7VNlcCeL/gmB1yEcZMAwA8+7vKXAmgj+BYHHTGTAMAPP67ylwJoM/gWDnonj1m2jt9AGDUAGmu BDBOcLxy0BkzDQDwmO8qcyWAvoNjdshFPHfMtHf6AMCo4bH2XWWuBNBvcCwOumePmfZOHwAYNUCa KwGMFxxnAuSaY6bfeqd/Cs8sAIAxA6S5EsA4wTE75CLWHTOt/wgAbD1AmisBjBMcrxxy94yZvrX/ mA46zywAgNHCY4S5EsBowbESIJ/Vf0wB0jMLAGC0AGmuBDBecLxy0N06ZrrlnX7tqYVnFgDAFgKk uRLAGMExO+Qi1u0/zi26/S08swAAxg2Pa39X6T+C4PjhDrp7+4/poMsX3eaHnGcWAMBWAqS5EsB4 wbFy0N36Tj9fdNty+2jMNACwlQBprgQwTnC8ctDd2n8sF93mt4+eWQAAWw6Q5koAYwXH7JCLaH+n X/6lLN0+RnHIGTMNAGwxPN7yXWWuBAiOXR50c+/0j9F2+1gGSGOmAYAtBkhzJUBw3MxBVz6zqL3R N2YaAOC27ypzJUBwHOqgK9/pH8KYaQCANb6rzJUAwXGYQy7i+jv98pAzZhoAYNl3lbkSIDgOc9AZ Mw0AsO53lbkSIDhuIkDuw5hpAIA1vqueOVfCH+ZBcHzKIRdhzDQAwJoB0lwJEByHPuSMmQYAuP+7 KuK5cyX8YR4Ex3cLkMZMAwC8z3fV0rkS/jAPguO7HHTGTAMArBsg15wrYa82CI4f4pCLMGYaAODZ 31X6jyA4dnnQGTMNAPD47yp7tUFwHOqgM2YaAOAx31X2aoPgONRBZ8w0AMBjvqvs1QbBcZhDLsKY aQCAR35X2asNguMwB50x0wAA635X2asNguMmAqQx0wAA63xX2asNguNwh1yEMdMAAGsGSHu1QXAc +pAzZhoA4P7vqgh7tUFw3EiANGYaAGCd7yp7tUFwHPqgM2YaAGC9AGmvNgiOQx5yEcZMAwCsGSDt 1QbBcehDzphpAID7v6si7NUGwXEjAdKYaQCA9/muslcbBMeuDjpjpgEA1g2Q9mqD4DjcIRdhzDQA wLO/q/QfQXDs8qAzZhoA4PHfVfZqg+A41EFnzDQAwGO+q+zVBsFxqIPOmGkAgMd8V9mrDYLjMIdc hDHTAACP/K6yVxsEx2EOOmOmAQDW/a6yVxsEx00ESGOmAQDW+a6yVxsEx+EOuQhjpgEA1gyQ9mqD 4Dj0IWfMNADA/d9VEfZqg+C4kQBpzDQAwDrfVfZqg+A49EFnzDQAwHoB8tl7tc2VQHDkKYdchDHT AABrBkh7tREcGfqQM2YaAOD+76qI5+7VNlcCwZF3C5DGTAMAvM93lbkSCI50ddAZMw0AsG6AXHOv trkSCI58iEMuwphpAIBnf1eZK4HgSJcHnTHTAACP/64yVwLBkaEOumePmfZOHwDYyneVuRIIjgx1 0BkzDQDwmO8qcyUQHBnmkIt47php7/QBgK19V5krgeDIMAfds8dMe6cPAIz+XWWuBIIjmwiQa46Z fuud/ik8swAAxv2uMlcCwZHhDrmIdcdM6z8CAFsPkOZKIDgy9CF3z5jpW/uP6aDzzAIAGO27KsJc CQRHNhIgn9V/TAHSMwsAwHeVuRIIjnR40N06ZrrlnX7tqYVnFgDAFgKkuRIIjgx3yEWs23+cW3T7 W3hmAQD4rtJ/RHCk24Pu3v5jOujyRbf5IeeZBQDgu8pcCQRHBjvobn2nny+6bbl9NGYaAPBdZa4E giMDHHS39h/LRbf57aNnFgCA7ypzJRAcGfCQi2h/p1/+pSzdPkZxyBkzDQD4rjJXAsGRAQ+6uXf6 x2i7fSwDpDHTAIDvKnMlEBwZ+KArn1nU3ugbMw0AcNt3lbkSCI4MddCV7/QPYcw0AMAa31XmSiA4 MswhF3H9nX55yBkzDQCw7LvKXAkER4Y56IyZBgBY97vKXAkERzYRIPdhzDQAwBrfVc+cK+EP84Ij POWQizBmGgBgzQBprgSCI0MfcsZMAwDc/10V8dy5Ev4wLzjCuwVIY6YBAN7nu2rpXAl/mBcc4V0O OmOmAQDWDZBrzpWwV1twhA9xyEUYMw0A8OzvKv1HBEe6POiMmQYAePx3lb3aCI4MddAZMw0A8Jjv Knu1ERwZ6qAzZhoA4DHfVfZqIzgyzCEXYcw0AMAjv6vs1UZwZJiDzphpAIB1v6vs1UZwZBMB0php AIB1vqvs1RYcYbhDLsKYaQCANQOkvdqCIwx9yBkzDQBw/3dVhL3agiNsJEAaMw0AsM53lb3agiMM fdAZMw0AsF6AtFdbcIQhD7kIY6YBANYMkPZqC44w9CFnzDQAwP3fVRH2aguOsJEAacw0AMD7fFfZ qy04QlcHnTHTAADrBkh7tQVHGO6QizBmGgDg2d9V+o+CI3R50BkzDQDw+O8qe7UFRxjqoDNmGgDg Md9V9moLjjDUQWfMNADAY76r7NUWHGGYQy7CmGkAgEd+V9mrLTjCMAedMdMAAOt+V9mrLTjCJgKk MdMAAOt8V9mrLTjCcIdchDHTAABrBkh7tQVHGPqQM2YaAOD+76oIe7UFR9hIgDRmGgBgne8qe7UF Rxj6oDNmGgBgvQD57L3a5koIjvCUQy7CmGkAgDUDpL3agiMMfcgZMw0AcP93VcRz92qbKyE4wrsF SGOmAQDe57vKXAnBEbo66IyZBgBYN0CuuVfbXAnBET7EIRdhzDQAwLO/q8yVEByhy4POmGkAgMd/ V5krITjCUAfds8dM6z8CAFv5rjJXQnCEoQ46Y6YBAB7zXWWuhOAIwxxyEc8dM63/CABs7bvKXAnB EYY56J49Zlr/EQAY/bvKXAnBETYRINccM/3WO/1TeL4KAIz7XWWuhOAIwx1yEeuOmdZ/BAC2HiDN lRAcYehD7p4x07f2H9NB5/kqADDad1WEuRKCI2wkQD6r/5gCpPUdAIDvqo3OlRAcoe+D7tYx0y3v 9GtPLTxfBQC2ECDNlRAcYbhDLmLd/uPcotvfwvoOAMB31Sb7j4IjjHHQ3dt/TAddvug2P+Ss7wAA fFdteK6E4AhjHnS3vtPPF9223D4OOWYaAGCF76oh50oIjjDuQXdr/7FcdJvfPlrfAQD4rtrwXAnB EcY95CLa3+mXfylLt49RHHJDj5kGAFjhu2rIuRKCI4x/0M290z9G2+1jGSCHHDMNAHDHd9XQcyUE R9jeQVc+s6i90d/cmGkAgDu/q4adKyE4wjYPuvKd/iGMmQYAWOO7asi5EoIjbPOQi7j+Tr885DY1 ZhoAYMXvqqHmSgiOsO2DzphpAIB1v6uGnCshOIKDrgyQ+9jomGkAgJW/q545V+Khf5gXHAFjpgEA HhMgh5krITgC1w65TY6ZBgBY+bsq4rlzJR72h3nBEXgrQG5mzDQAwAf7rlo6V2L1P8wLjkDLQbeJ MdMAAE8MkGvOlXj4Xm3BEWg55CI2MGYaAOCDfVd9mP6j4AjcctANPWYaAOCDfFd9uL3agiNwz0E3 1JhpAIAP9F316L3aNz1fFRyBew+6YcZMAwB8sO+qR+zV/i3qf5iv3j4KjsC9h1zEIGOmAQA+6HfV mnu18z/OlwGy+k0lOAJrHXTdj5kGAPhg31WP2Kv9SyVAXvxRvvyeEhyBRwbIrsZMAwB84O+qe/dq p1ddKTz+koXI/A/zf/5BXnAEnnHIRXQ4ZhoA4AMHyHv2akd8rwX9noXGf02/X7Lvqm9/jM+/owRH 4NGHXDdjpgEAPvB3VcSyvdrpu+pT9k31WxYc/zn989fse+ovt46CI/DMAPnsMdPWdwAAo35X3bJX +6UIj39M30//ysLjL9m31ElwBN77oHvGmOn01MLzVQBg9AD51l7tYxYe07PVNDAnD4+/ZN9RgiPw 7odcxOPHTOe3kdZ3AACjB8i39mrnr7m+/nfyJ6v5pFU3jsCHPOQeNWZ6bsmt/iMAMNp3VcT8Xu30 K7+hyvpPqvzoOAIfNkCuMWZ67vaxNn1V/xEAGP27Kn1bpeGDef3nj7icEfEapqoCH/ygu2fMdCp7 p9tH6zsAAAHy+8uu9NtlOTB9O6U/wH97mWWPI/CRD7mIZWOm89vHiMvhOXPrO/QfAYCtfFftsv85 /eef4/IVVvWP6YIj8BEPuiVjpsvbxzJAzq3v0H8EAEb+rooiMOY58HP5u/b9IzgCPQTIt8ZM5+Gx ZX2H/iMAsLXvqngjOP6p9t0jOAK9BMi3xky3ru8on6/qPwIAWwyR8VZYFByBXg+4uTHTb63vSP3H tLdI/xEAoJHgCPQWIJeu7ziE/iMAgOAIbDZA7qNtfcca/cdTeL4KAAiOAN2Ex4j29R36jwAAgiOw 4QA5t77jEf3HFCA9XwUABEeATgPks/qPKUBa3wEACI4AHQbI3UyAXNp/rD1h9XwVABAcAToMjxHr 9h9fK+Ex/azvAAAER4BOA+S9/ccUIM9TICyH51jfAQAIjgCDBchb+48vU3jcRdvtY236qv4jACA4 AnQUIG/tPx7jsv+Y3z5a3wEACI4AA4bHiPb+Y3kDmW4fIy6H58yt79B/BAAER4BOA+Rc//EYbbeP ZYCcW9+h/wgACI4AnQfI8vlqrfvYur5D/xEAEBwBBgyQZf/xEMvWd5TPV/UfAQDBEWCQ8Bhxvf9Y Ds+pre9I/cdz6D8CAIIjwNABcun6jkPoPwIAgiPAZgPkPtrWd6zRfzyF56sAgOAI0E14jGhf36H/ CAAIjgAbDpBz6zse0X9MAdLzVQBAcAToNEA+q/+YAqT1HQCA4AjQYYDczQTIpf3H2hNWz1cBAMER oMPwGLFu//G1Eh7Tz/oOAEBwBOg0QN7bf0wB8jwFwnJ4jvUdAIDgCDBYgLy1//gyhcddtN0+1qav 6j8CAIIjQEcB8tb+4zEu+4/57aP1HQCA4AgwYHiMaO8/ljeQ6fYx4nJ4ztz6Dv1HAEBwBOg0QM71 H4/RdvtYBsi59R36jwCA4AjQeYAsn6/Wuo+t6zve6j+ewvNVAEBwBOguQJb9x0MsW99RPl/VfwQA BEeAQcJjxPX+Yzk8p7a+I/Ufz9HWf0wB0vNVAEBwBOgsQC5d33GIZf3HFCCt7wAABEeAjgPkPtrW d7T0H2tPWD1fBQAER4AOw2NE+/qOlv7jayU8pp/1HQCA4AjQaYCcW9/R0n9MAfI8BcJyeI71HQCA 4AgwWIC8tf/4MoXHXbTdPtamr+o/AgCCI0BHAXI3EyCv9R+Pcdl/zG8fre8AAARHgAHDY0R7/7G8 gUy3jxGXw3Pm1nfoPwIAgiNApwFyrv94jLbbxzJAzq3v0H8EAARHgM4DZPl8tdZ9bF3fof8IAAiO AAMGyLL/eIhl6zvK56v6jwCA4AgwSHiMuN5/LIfn1NZ3pP7jOfQfAQDBEWDoALl0fcch9B8BAMER YLMBch9t6zvW6D+ewvNVABAcAegmPEa0r+/QfwQABEeADQfIufUdj+g/pgDp+SoACI4AdBogn9V/ TAHS+g4AEBwB6DBA7mYC5NL+Y+0Jq+erACA4AtBheIxYt//4WgmP6Wd9BwAIjgB0GiDv7T+mAHme AmE5PMf6DgAQHAEYLEDe2n98mcLjLtpuH2vTV/UfAUBwBKCjAHlr//EYl/3H/PbR+g4AEBwBGDA8 RrT3H8sbyHT7GHE5PGdufYf+IwAIjgB0GiDn+o/HaLt9LAPk3PoO/UcAEBwB6DxAls9Xa93H1vUd +o8AIDgCMGCALPuPh1i2vqN8vqr/CACCIwCDhMeI6/3HcnhObX1H6j+eQ/8RAARHAIYOkEvXdxxC /xEABEcANhsg99G2vmON/uMpPF8FAMERgG7CY0T7+g79RwAQHAHYcICcW9/xiP5jCpCerwKA4AhA pwHyWf3HFCCt7wAAwRGADgPkbiZALu0/1p6wer4KAIIjAB2Gx4h1+4+vlfCYftZ3AIDgCECnAfLe /mMKkOcpEJbDc6zvAADBEYDBAuSt/ceXKTzuou32sTZ9Vf8RAARHADoKkLf2H49x2X/Mbx+t7wAA wRGAAcNjRHv/sbyBTLePEZfDc+bWd+g/AoDgCECnAXKu/3iMttvHMkDOre/QfwQAwRGAzgNk+Xy1 1n1sXd/xVv/xFJ6vAoDgCEB3AbLsPx5i2fqO8vmq/iMACI4ADBIeI673H8vhObX1Han/eI62/mMK kJ6vAoDgCEBnAXLp+o5DLOs/pgBpfQcACI4AdBwg99G2vqOl/1h7wur5KgAIjgB0GB4j2td3tPQf XyvhMf2s7wAAwRGATgPk3PqOlv5jCpDnKRCWw3Os7wAAwRGAwQLkrf3Hlyk87qLt9rE2fVX/EQDB EQA6CpC7mQB5rf94jMv+Y377aH0HAAiOAAwYHiPa+4/lDWS6fYy4HJ4zt75D/xEAwREAOg2Qc/3H Y7TdPpYBcm59h/4jAIIjAHQeIMvnq7XuY+v6Dv1HAARHABgwQJb9x0MsW99RPl/VfwRAcASAQcJj xPX+Yzk8p7a+I/Ufz6H/CIDgCABDB8il6zsOof8IAIIjAJsNkPtoW9+xRv/xFJ6vAiA4AkA34TGi fX2H/iMACI4AbDhAzq3veET/MQVIz1cBEBwBoNMA+az+YwqQ1ncAIDgCQIcBcjcTIJf2H2tPWD1f BUBwBIAOw2PEuv3H10p4TD/rOwAQHAGg0wB5b/8xBcjzFAjL4TnWdwAgOALAYAHy1v7jyxQed9F2 +1ibvqr/CIDgCAAdBchb+4/HuOw/5reP1ncAIDgCwIDhMaK9/1jeQKbbx4jL4Tlz6zv0HwEQHAGg 0wA51388RtvtYxkg59Z36D8CIDgCQOcBsny+Wus+tq7v0H8EQHAEgAEDZNl/PMSy9R3l81X9RwAE RwAYJDxGXO8/lsNzaus7Uv/xHPqPAAiOADB0gFy6vuMQ+o8ACI4AsNkAuY+29R1r9B9P4fkqAIIj AHQTHiPa13foPwIgOALAhgPk3PqOR/QfU4D0fBUAwREAOg2Qz+o/pgBpfQcAgiMAdBggdzMBcmn/ sfaE1fNVAARHAOgwPEas2398rYTH9LO+AwDBEQA6DZD39h9TgDxPgbAcnmN9BwCCIwAMFiBv7T++ TOFxF223j7Xpq/qPAAiOANBRgLy1/3iMy/5jfvtofQcAgiMADBgeI9r7j+UNZLp9jLgcnjO3vkP/ EQDBEQA6DZBz/cdjtN0+lgFybn2H/iMAgiMAdB4gy+erte5j6/oO/UcABEcAGDBAlv3HQyxb31E+ X9V/BEBwBIBBwmPE9f5jOTyntr4j9R/Pof8IgOAIAEMHyKXrOw6h/wiA4AgAmw2Q+2hb37FG//EU nq8CCI4AQDfhMaJ9fYf+IwCCIwBsOEDOre94RP8xBUjPVwEERwCg0wD5rP5jCpDWdwAIjgBAhwFy NxMgl/Yfa09YPV8FEBwBgA7DY8S6/cfXSnhMP+s7AARHAKDTAHlv/zEFyPMUCMvhOdZ3AAiOAMBg AfLW/uPLFB530Xb7WJu+qv8IIDgCAB0FyFv7j8e47D/mt4/WdwAIjgDAgOExor3/WN5AptvHiMvh OXPrO/QfAQRHAKDTADnXfzxG2+1jGSDn1nfoPwIIjgBA5wGyfL5a6z62ru94q/94Cs9XAQRHAKC7 AFn2Hw+xbH1H+XxV/xFAcAQABgmPEdf7j+XwnNr6jtR/PEdb/zEFSM9XAQRHAKCzALl0fcchlvUf U4C0vgNAcAQAOg6Q+2hb39HSf6w9YfV8FUBwBAA6DI8R7es7WvqPr5XwmH7WdwAIjgBApwFybn1H S/8xBcjzFAjL4TnWdwAIjgDAYAHy1v7jyxQed9F2+1ibvqr/CCA4AgAdBcjdTIC81n88xmX/Mb99 tL4DQHAEAAYMjxHt/cfyBjLdPkZcDs+ZW9+h/wggOAIAnQbIuf7jMdpuH8sAObe+Q/8RQHAEADoP kOXz1Vr3sXV9h/4jgOAIAAwYIMv+4yGWre8on6/qPwIIjgDAIOEx4nr/sRyeU1vfkfqP59B/BBAc AYChA+TS9R2H0H8EEBwBgM0GyH20re9Yo/94Cs9XAQRHAKCb8BjRvr5D/xFAcAQANhwg59Z3PKL/ mAKk56sAgiMA0GmAfFb/MQVI6zsABEcAoMMAuZsJkEv7j7UnrJ6vAgiOAECH4TFi3f7jayU8pp/1 HQCCIwDQaYC8t/+YAuR5CoTl8BzrOwAERwBgsAB5a//xZQqPu2i7faxNX9V/BBAcAYCOAuSt/cdj XPYf89tH6zsABEcAYMDwGNHefyxvINPtY8Tl8Jy59R36jwCCIwDQaYCc6z8eo+32sQyQc+s79B8B wdG/AgCg8wBZPl+tdR9b13foPwIIjgDAgAGy7D8eYtn6jvL5qv4jgOAIAAwSHiOu9x/L4Tm19R2p /3gO/UcAwREAGDpALl3fcYhl/cc/svDo+SogOAIAdBog99G2vuOe/uO1AGl4DjCMnX8FAMBIprD2 Ob7vbXyNy2en//ry+7/p97/Z75/Tf/779H/3Kb5Pav3py+/nL79/fPn9x/TPv0//u5+m8JkHT99Y wFDcOAIAw2pY37G0/5g/Xb02ROfb8By3joDgCADQX4C8p/+YbjLz4Tm/ZL88QH4bnCM8Ar37wb8C AGB06fnqFCA/Z78U7tJN4h9ZKKz1H3dToEwBNAXSiGLHY/ZPgK55fw8AbC5AZmFxaf8xphCZ31am 3w9FoPTCC+iegwwA2KSF/ccyHKbe469TuPznFD5/mcJo2vXouSrQNU9VAYBNKp6v5v3FU/z1CWsa elM+XY3s/6YMhv5ADwiOAAADBsjW/mN+6/g5vj97TXscP4duIzAQHUcAgLip/5h3H7/+z+l56q9T sBQegeF4QgEAUJjpP6aBOKkHmdZ0pOeq+c3ktxtI/Uagd56qAgAUGvqPKUTuot6PtIoDGIYbRwCA NxQ3kLu4vsMxhceLPY5uGwHBEQBgW+Ex4vIJa/ktlQ/XsYIDEBwBAATIi2+qz1l4DKEREBwBAMhD 5DcCIwAAAAAAAABA7t8CDACQvd9t8c8JxgAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 821 486)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1418.5,
    y1: 1006,
    x2: 831.4,
    y2: 667.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1720.8,
    y1: 835.2,
    x2: 1133.7,
    y2: 496.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 695.6,
    y1: 923.4,
    x2: 1509.4,
    y2: 453.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 182,
    y1: 1219.9,
    x2: 1509.4,
    y2: 453.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 520.7,
    y1: 1414.7,
    x2: 1323.3,
    y2: 951.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1128.4,
    y1: 1173.5,
    x2: 593.8,
    y2: 864.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1806.8,
    y1: 781.5,
    x2: 1221.5,
    y2: 443.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1025,
    y1: 1233.2,
    x2: 439,
    y2: 893.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "1228.2,614.2 1215.6,606.9 1156.5,641.1 1169.1,648.3  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 105,
    y1: 1147.9,
    x2: 1416.1,
    y2: 391
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "913.6,797.8 881.5,779.5 731.5,866.1 763.6,884.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#43FFBB",
    enableBackground: "new    ",
    points: "1346.5,548.4 1359.2,555.6 1418.3,521.5 1405.6,514.2  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -2027.2289,
    y1: 242.0542,
    x2: -1820.7289,
    y2: -115.6157,
    gradientTransform: "matrix(-0.97 0.23 -0.23 -0.97 -1497.76 899.7801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F4FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#E1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#C2F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFF8FF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "url(#SVGID_3_)",
    enableBackground: "new    ",
    d: "M87.2,444.2c24.9,106,146.4,168.1,271.3,138.7 c33.1-7.7,64.5-21.6,92.4-41.1l123.2,13.8c4.6,1,9.1-1.9,10.1-6.5c0.5-2.1,0.1-4.3-1.1-6.2l-50.8-103c12.3-32.5,15.5-67.4,7.3-102 c-24.9-106-146.4-168-271.3-138.6S62.3,338.2,87.2,444.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -2031.9371,
    y1: -176.0892,
    x2: -1777.6471,
    y2: 264.3508,
    gradientTransform: "matrix(-0.97 0.23 -0.23 -0.97 -1497.76 899.7801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BFF8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C2F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#E1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#F4FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBFBFB"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "url(#SVGID_4_)",
    enableBackground: "new    ",
    d: "M87.2,444.2c24.9,106,146.4,168.1,271.3,138.7 c33.1-7.7,64.5-21.6,92.4-41.1l123.2,13.8c4.6,1,9.1-1.9,10.1-6.5c0.5-2.1,0.1-4.3-1.1-6.2l-50.8-103c12.3-32.5,15.5-67.4,7.3-102 c-24.9-106-146.4-168-271.3-138.6S62.3,338.2,87.2,444.2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#43FFBB",
    cx: 760.6,
    cy: 767.1,
    rx: 13.6,
    ry: 9.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#43FFBB",
    cx: 261.5,
    cy: 1057.3,
    rx: 13.6,
    ry: 9.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#43FFBB",
    cx: 1281.5,
    cy: 458.6,
    rx: 13.6,
    ry: 9.5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#43FFBB",
    cx: 1247.6,
    cy: 1045,
    rx: 13.6,
    ry: 9.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#43FFBB",
    cx: 748.4,
    cy: 1335.2,
    rx: 13.6,
    ry: 9.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#43FFBB",
    cx: 1734.4,
    cy: 760,
    rx: 13.6,
    ry: 9.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#43FFBB",
    enableBackground: "new    ",
    points: "440,1370.3 215.4,1240.7 1517.7,488 1522.7,496.4  1673.1,583.7 1716.9,572.7 1767.5,598.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 747.77,
    y1: 770.2737,
    x2: 1049.34,
    y2: 770.2737,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M747.8,1201.2c0,1.8,1.2,3.6,3.6,5l138.5,80c4.8,2.8,12.6,2.8,17.3,0l138.6-80 c2.4-1.4,3.6-3.2,3.6-5v-29.9c0,1.8-1.2,3.6-3.6,5l-138.6,80c-4.8,2.8-12.5,2.8-17.3,0l-138.5-80c-2.4-1.4-3.6-3.2-3.6-5V1201.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 747.77,
    y1: 828.77,
    x2: 1049.3401,
    y2: 828.77,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M751.3,1176.2c-4.8-2.8-4.8-7.2,0-10l138.6-80c4.8-2.8,12.6-2.8,17.3,0l138.5,80 c4.8,2.8,4.8,7.2,0,10l-138.6,80c-4.8,2.8-12.5,2.8-17.3,0L751.3,1176.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 747.77,
    y1: 813.9638,
    x2: 1049.34,
    y2: 813.9638,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M747.8,1157.5c0,1.8,1.2,3.6,3.6,5l138.5,80c4.8,2.8,12.6,2.8,17.3,0l138.6-80 c2.4-1.4,3.6-3.2,3.6-5v-29.9c0,1.8-1.2,3.6-3.6,5l-138.6,80c-4.8,2.8-12.5,2.8-17.3,0l-138.5-80c-2.4-1.4-3.6-3.2-3.6-5V1157.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 747.77,
    y1: 872.45,
    x2: 1049.3401,
    y2: 872.45,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M751.3,1132.6c-4.8-2.8-4.8-7.2,0-10l138.6-80c4.8-2.8,12.6-2.8,17.3,0l138.5,80 c4.8,2.8,4.8,7.2,0,10l-138.6,80c-4.8,2.8-12.5,2.8-17.3,0L751.3,1132.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 747.77,
    y1: 864.2137,
    x2: 1049.34,
    y2: 864.2137,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "url(#SVGID_9_)",
    enableBackground: "new    ",
    d: "M747.8,1107.2c0,1.8,1.2,3.6,3.6,5l138.5,80 c4.8,2.8,12.6,2.8,17.3,0l138.6-80c2.4-1.4,3.6-3.2,3.6-5v-29.9c0,1.8-1.2,3.6-3.6,5l-138.6,80c-4.8,2.8-12.5,2.8-17.3,0l-138.5-80 c-2.4-1.4-3.6-3.2-3.6-5V1107.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M751.3,1082.3c-4.8-2.8-4.8-7.2,0-10l138.6-80c4.8-2.8,12.6-2.8,17.3,0l138.5,80c4.8,2.8,4.8,7.2,0,10 l-138.6,80c-4.8,2.8-12.5,2.8-17.3,0L751.3,1082.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -337.1214,
    y1: -1161.5238,
    x2: -444.5314,
    y2: -1120.8038,
    gradientTransform: "matrix(0.866 0.5 0.5 -0.866 1198.51 576.6407)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M322.5,1406.7l-63.7-36.7c-2.2-1.3-3.6-3.7-3.6-6.2l-0.1-13.3c-0.1-4,3.1-7.4,7.1-7.4 c1.3,0,2.6,0.3,3.8,1l63.9,37c2.3,1.3,3.6,3.7,3.6,6.3l-0.1,13.1c0,4-3.3,7.3-7.3,7.3C324.9,1407.7,323.6,1407.4,322.5,1406.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 3126.0171,
    y1: -4486.8735,
    x2: 3018.5969,
    y2: -4446.1533,
    gradientTransform: "matrix(0.87 -0.5 0.5 0.87 1198.51 6382.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M1653.7,945.1l-63.7,36.8c-2.2,1.3-3.6,3.7-3.6,6.2l-0.1,13.3c0,4,3.2,7.3,7.2,7.3 c1.3,0,2.6-0.3,3.7-1l63.9-37c2.3-1.3,3.6-3.7,3.6-6.3l-0.1-13.1c0-4-3.3-7.2-7.3-7.2C1656.1,944.1,1654.8,944.5,1653.7,945.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 3234.9429,
    y1: -4485.5015,
    x2: 3127.533,
    y2: -4444.7817,
    gradientTransform: "matrix(0.87 -0.5 0.5 0.87 1198.51 6382.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M1749,892.1l-63.7,36.8c-2.2,1.3-3.6,3.7-3.6,6.2l-0.1,13.3c0,4,3.2,7.3,7.2,7.3 c1.3,0,2.6-0.3,3.7-1l63.9-37c2.3-1.3,3.6-3.7,3.6-6.3l-0.1-13.1c0-4-3.3-7.3-7.3-7.2C1751.3,891.1,1750.1,891.4,1749,892.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M1006.9,1245.6l-226.6,130.5l-113.3,65.3c-9.4,5.8-19.6,9.9-30.3,12.3c-5.3,1.2-10.8,2-16.3,2.3 c-5.5,0.4-11,0.3-16.4-0.3c-5.5-0.6-10.9-1.6-16.1-3.2c-5.3-1.6-10.4-3.7-15.2-6.2c-1.2-0.6-2.4-1.3-3.6-2l-3.5-2l-7.1-4.1 l-14.2-8.2l-226.6-130.6l-113.3-65.3l-56.7-32.7l-1.8-1l-1.7-1.1l-3.4-2.3c-1.2-0.7-2.2-1.6-3.4-2.4l-3.3-2.5 c-4.3-3.4-8.3-7.2-12.1-11.3c-1.9-2-3.6-4.2-5.3-6.4c-0.8-1.1-1.6-2.3-2.4-3.4l-1.2-1.7c-0.4-0.6-0.7-1.2-1.1-1.8l-2.1-3.6 l-1.8-3.7c-1.2-2.5-2.2-5.1-3.1-7.7c-1.8-5.3-2.9-10.7-3.4-16.2l-0.2-2.1l-0.1-1v-1v-4.2l0.3-4.2l0.1-1l0.2-1l0.3-2.1l0.3-2.1 l0.4-2c0.3-1.3,0.5-2.7,1-4l1.2-4l1.4-3.9c2-5.2,4.6-10.1,7.6-14.8c3.1-4.6,6.5-8.9,10.4-12.9c3.8-4,8-7.7,12.4-11 c4.5-3.1,9.3-6,14.2-8.5c4.8-2.5,9.7-5,14.4-7.6l113.3-65.2l226.7-130.5l453.2-261l226.6-130.6l113.3-65.3l14.2-8.2l7.1-4.1 c1.2-0.7,2.4-1.4,3.6-2s2.4-1.4,3.7-1.9c20.5-9.8,44-11.2,65.5-3.9c5.3,1.9,10.4,4.2,15.3,7l13.8,8.8l55,35.4l27.5,17.7l13.8,8.9 l1.7,1.1c0.7,0.4,1.3,0.9,1.9,1.4c1.3,1.1,2.3,2.4,3.2,3.9c1.6,2.9,2.2,6.3,1.6,9.6c-0.1,0.8-0.4,1.7-0.7,2.4 c-0.3,0.9-0.6,1.4-0.9,2l-1.7,3.7l-1.7,3.7l-0.4,0.9c-0.1,0.3-0.3,0.6-0.4,0.9c-0.2,0.5-0.4,1-0.5,1.5c-0.4,2.1-0.1,4.2,1,6.1 c0.5,0.9,1.2,1.7,2,2.3c0.2,0.2,0.4,0.3,0.6,0.5c0.2,0.1,0.5,0.3,0.8,0.5l1.8,1l28.3,16.4l56.6,32.8l28.3,16.4l14.1,8.2l7.1,4.1 l3.5,2c0.6,0.3,1.2,0.7,1.7,1s1,0.5,1.6,0.8c2.3,0.9,4.7,1.5,7.2,1.8c2.4,0.3,4.9,0.2,7.3-0.2l15.8-4l7.9-2l1-0.2l1.2-0.2 c0.8-0.1,1.5-0.2,2.3-0.3c1.5-0.1,3-0.1,4.4-0.1c2.9,0.1,5.8,0.6,8.7,1.4c0.7,0.2,1.4,0.5,2.1,0.7s1.5,0.7,2.1,0.9l3.7,1.8 l58.4,29.5l29.2,14.8l7.3,3.7l1.8,0.9c0.6,0.3,1.2,0.7,1.8,1.1l3.6,2.2c1.2,0.8,2.3,1.6,3.4,2.5l1.7,1.2l1.6,1.3 c1.1,0.9,2.2,1.8,3.2,2.7l3,2.9c8,7.9,14.3,17.4,18.6,27.8c2.1,5.2,3.8,10.6,4.9,16.1c1.1,5.5,1.6,11.1,1.7,16.7 c0.1,11.2-2,22.4-6.2,32.8c-4.2,10.5-10.4,20-18.2,28c-2,1.9-4,3.9-6.2,5.7l-1.6,1.3c-0.5,0.5-1.1,0.9-1.7,1.3l-3.4,2.5 c-1.1,0.8-2.3,1.5-3.5,2.3s-2.4,1.5-3.6,2.2l-7.1,4.1l-28.3,16.3l-56.7,32.6l-226.6,130.6l-226.8,130.3l-226.9,130.1l-0.2-0.4 l226-131.6l226.1-131.3l226.2-131.2l56.6-32.8l28.3-16.4l7.1-4.1c1.2-0.7,2.3-1.4,3.4-2.1s2.3-1.4,3.3-2.2l3.2-2.3 c0.5-0.4,1.1-0.8,1.6-1.2l1.5-1.3c2.1-1.6,3.9-3.5,5.9-5.4c7.4-7.6,13.3-16.6,17.2-26.5c1.9-4.9,3.4-10,4.4-15.2 c0.9-5.2,1.4-10.5,1.4-15.8c-0.1-5.3-0.6-10.6-1.6-15.8c-1-5.2-2.6-10.3-4.6-15.2c-4.1-9.8-10-18.7-17.6-26.1l-2.9-2.7 c-1-0.9-2-1.7-3-2.5l-1.5-1.3l-1.6-1.2c-1.1-0.8-2.1-1.6-3.2-2.3l-3.3-2.1c-0.6-0.3-1.1-0.7-1.7-1l-1.8-0.9l-7.3-3.7l-29.2-14.7 l-58.3-29.4l-3.7-1.8l-0.8-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.5-0.2-1.1-0.4-1.7-0.6c-2.4-0.7-4.9-1.1-7.4-1.2 c-1.2-0.1-2.5,0-3.7,0.1c-0.6,0.1-1.2,0.1-1.8,0.2l-0.8,0.2l-1,0.2l-7.9,2l-15.9,4c-3,0.6-6,0.7-9,0.4c-3-0.3-5.9-1-8.6-2.1 c-0.7-0.3-1.4-0.6-2.1-1c-0.7-0.4-1.2-0.7-1.8-1l-3.5-2l-7.1-4.1l-14.1-8.2l-28.3-16.4l-56.5-32.8l-28.3-16.6l-1.8-1 c-0.3-0.2-0.6-0.3-1-0.6c-0.3-0.2-0.7-0.5-1-0.7c-1.3-1-2.4-2.3-3.3-3.8c-1.7-2.9-2.3-6.4-1.6-9.7c0.2-0.8,0.4-1.6,0.8-2.4 c0.2-0.4,0.3-0.7,0.5-1l0.4-0.9l1.7-3.7l1.7-3.7c0.5-1,0.9-2.1,1.2-3.2c0.4-2.1,0-4.3-1.1-6.2c-0.5-0.9-1.2-1.7-2-2.4 c-0.7-0.6-2-1.4-3.1-2.1l-13.7-8.9l-27.5-17.7l-54.9-35.4l-13.7-8.9c-4.6-2.6-9.4-4.8-14.4-6.6c-15.1-5.2-31.4-5.9-46.9-1.9 c-5.1,1.4-10.1,3.2-14.9,5.4c-1.2,0.5-2.3,1.2-3.5,1.8s-2.3,1.2-3.5,1.9l-7.1,4.1l-14.1,8.1l-113.4,65.1L960.7,595.8L507.1,856.2 L280.3,986.4l-113.4,65.1c-9.6,5.4-19.6,9.7-28.4,16c-4.3,3.2-8.4,6.7-12.2,10.5c-3.7,3.9-7.1,8.1-10.1,12.5 c-2.9,4.5-5.4,9.3-7.3,14.3l-1.4,3.8l-1.1,3.8c-0.4,1.3-0.6,2.6-0.9,3.9l-0.4,2l-0.3,2l-0.3,2l-0.1,1l-0.1,1l-0.3,4v5l0.1,1l0.2,2 c0.4,5.3,1.5,10.6,3.2,15.7c0.4,1.3,0.9,2.5,1.4,3.8c0.5,1.2,1,2.5,1.6,3.7l1.8,3.6l2,3.5c0.3,0.6,0.7,1.2,1,1.7l1.1,1.7 c0.8,1.1,1.5,2.2,2.3,3.3c1.7,2.1,3.3,4.3,5.1,6.2c3.6,4,7.6,7.7,11.8,11l3.2,2.4c1.1,0.8,2.1,1.7,3.3,2.4l3.4,2.2l1.7,1.1l1.8,1 l56.6,32.7l113.2,65.5l226.3,131l14.2,8.2l7.1,4.1l3.5,2c1.2,0.7,2.3,1.4,3.5,2c4.8,2.5,9.8,4.6,15,6.1c5.2,1.5,10.5,2.6,15.9,3.2 c5.4,0.6,10.8,0.7,16.2,0.3c5.4-0.3,10.7-1.1,16-2.3c10.6-2.3,20.8-6.4,30-12.1l113.4-65.1l226.8-130.1L1006.9,1245.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M898.4,1307.5l45-27l45.1-26.8l11.3-6.7l5.6-3.4l2.8-1.7c0.5-0.3,1-0.6,1.4-0.8c0.4-0.2,0.7-0.5,1.1-0.8 c1.5-1.2,2.7-2.7,3.6-4.3c1-1.6,1.7-3.4,2.2-5.2c0.2-0.9,0.3-1.8,0.3-2.7v-3.3l0.1-6.6l0.1-3.3c0-1.1,0.1-2.3,0-3.1 c-0.1-0.9-0.2-1.8-0.5-2.7c-0.3-0.9-0.6-1.8-1-2.7c-0.8-1.8-2-3.4-3.3-4.7c-0.7-0.7-1.4-1.3-2.2-1.8c-0.8-0.5-1.9-1.1-2.8-1.6 c-7.6-4.3-15.1-8.8-22.5-13.5l0.2-0.4c8.1,3.4,16,7.1,23.9,10.8c1,0.5,1.9,0.9,3,1.4c1.1,0.6,2.1,1.3,3.1,2.1 c1.8,1.6,3.4,3.5,4.5,5.7c1.2,2.2,2,4.5,2.3,7c0.1,1.4,0.1,2.4,0.1,3.5l0.1,3.3l0.1,6.6v3.3c0,1.3-0.1,2.6-0.4,3.8 c-0.6,2.4-1.5,4.7-2.9,6.8c-1.3,2.1-3,4-5,5.5c-0.5,0.4-1.1,0.7-1.6,1.1l-1.5,0.8l-2.9,1.6l-5.7,3.2l-11.5,6.3l-45.8,25.5l-46,25.3 L898.4,1307.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 1452.1494,
    y1: 2120.5886,
    x2: 1583.6052,
    y2: 1892.9005,
    gradientTransform: "matrix(0.9916 -0.1297 -0.1297 -0.9916 -492.5981 2614.7766)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F4FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#E1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#C2F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFF8FF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "url(#SVGID_13_)",
    enableBackground: "new    ",
    d: "M919.3,393.3c9,68.7-49.4,133-130.4,143.6 c-21.5,2.9-43.3,1.6-64.3-3.7l-70.3,35.9c-2.5,1.6-5.8,0.9-7.4-1.6c-0.7-1.2-1-2.6-0.8-3.9l7.1-72.8 c-14.8-16.5-24.3-37.1-27.2-59.1c-9-68.7,49.4-133,130.4-143.6S910.4,324.6,919.3,393.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 1452.1494,
    y1: 2120.5886,
    x2: 1583.6052,
    y2: 1892.9005,
    gradientTransform: "matrix(0.9916 -0.1297 -0.1297 -0.9916 -492.5981 2614.7766)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F4FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#E1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#C2F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFF8FF"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "url(#SVGID_14_)",
    enableBackground: "new    ",
    d: "M919.3,393.3c9,68.7-49.4,133-130.4,143.6 c-21.5,2.9-43.3,1.6-64.3-3.7l-70.3,35.9c-2.5,1.6-5.8,0.9-7.4-1.6c-0.7-1.2-1-2.6-0.8-3.9l7.1-72.8 c-14.8-16.5-24.3-37.1-27.2-59.1c-9-68.7,49.4-133,130.4-143.6S910.4,324.6,919.3,393.3z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M1048.9,343.3c-4.8-2.8-4.8-7.2,0-10l138.6-80c4.8-2.8,12.6-2.8,17.3,0l138.5,80c4.8,2.8,4.8,7.2,0,10 l-138.6,80c-4.8,2.8-12.6,2.8-17.3,0L1048.9,343.3z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "#43FFBB",
    enableBackground: "new    ",
    d: "M1346.9,338.3c0-1.8-1.2-3.6-3.6-5l-138.5-80 c-4.8-2.8-12.6-2.8-17.3,0l-138.6,80c-2.4,1.4-3.6,3.2-3.6,5v-29.9c0-1.8,1.2-3.6,3.6-5l138.6-80c4.8-2.8,12.6-2.8,17.3,0l138.5,80 c2.4,1.4,3.6,3.2,3.6,5L1346.9,338.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1045.33,
    y1: 1494.2188,
    x2: 1346.9,
    y2: 1494.2188,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M1045.3,567.7c0,1.8,1.2,3.6,3.6,5l138.6,80c4.8,2.8,12.6,2.8,17.3,0l138.6-80 c2.4-1.4,3.6-3.2,3.6-5V356.8c0,1.8-1.2,3.6-3.6,5l-138.6,80c-4.8,2.8-12.6,2.8-17.3,0l-138.6-80c-2.4-1.4-3.6-3.2-3.6-5V567.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 1045.3325,
    y1: 1643.2119,
    x2: 1346.8999,
    y2: 1643.2119,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M1048.9,361.8c-4.8-2.8-4.8-7.2,0-10l138.6-80c4.8-2.8,12.6-2.8,17.3,0l138.5,80 c4.8,2.8,4.8,7.2,0,10l-138.6,80c-4.8,2.8-12.6,2.8-17.3,0L1048.9,361.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    enableBackground: "new    ",
    d: "M1264.3,407.4l22.1-12.7c0.9-0.5,2-0.2,2.5,0.7 c0.2,0.3,0.2,0.6,0.2,0.9v165.4c0,0.9-0.5,1.7-1.2,2.1l-22.1,12.7c-0.9,0.5-2,0.2-2.5-0.7c-0.2-0.3-0.2-0.6-0.2-0.9V409.6 C1263.1,408.7,1263.5,407.9,1264.3,407.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    enableBackground: "new    ",
    d: "M1310.3,421.6l22.1-12.7c0.9-0.5,2-0.2,2.5,0.7 c0.2,0.3,0.2,0.6,0.2,0.9v165.4c0,0.9-0.5,1.7-1.2,2.1l-22.1,12.7c-0.9,0.5-2,0.2-2.4-0.6c-0.2-0.3-0.2-0.6-0.2-0.9V423.7 C1309,422.8,1309.5,422,1310.3,421.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 1045.33,
    y1: 1632.8087,
    x2: 1346.9,
    y2: 1632.8087,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "url(#SVGID_17_)",
    enableBackground: "new    ",
    d: "M1045.3,338.6c0,1.8,1.2,3.6,3.6,5l138.6,80 c4.8,2.8,12.6,2.8,17.3,0l138.6-80c2.4-1.4,3.6-3.2,3.6-5v-29.9c0,1.8-1.2,3.6-3.6,5l-138.6,80c-4.8,2.8-12.6,2.8-17.3,0l-138.6-80 c-2.4-1.4-3.6-3.2-3.6-5V338.6z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M1048.9,313.7c-4.8-2.8-4.8-7.2,0-10l138.6-80c4.8-2.8,12.6-2.8,17.3,0l138.5,80c4.8,2.8,4.8,7.2,0,10 l-138.6,80c-4.8,2.8-12.6,2.8-17.3,0L1048.9,313.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#43FFBB",
    enableBackground: "new    ",
    d: "M1411.4,448.2l235.3-107.1c1.3-0.6,2.9,0,3.5,1.3 c0.3,0.6,0.3,1.3,0.1,1.9l-62.5,211c-0.4,1.4-1.9,2.2-3.3,1.8c-0.3-0.1-0.6-0.2-0.9-0.4l-69.4-53.2l-18,32.5 c-0.7,1.3-2.3,1.8-3.6,1.1c-0.5-0.3-0.9-0.7-1.1-1.1l-28.4-55.6l-52-27.3c-1.3-0.7-1.8-2.3-1-3.6 C1410.5,448.9,1410.9,448.5,1411.4,448.2z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#43FFBB",
    enableBackground: "new    ",
    d: "M1463.2,480.4l183.5-139.2c1.3-0.6,2.9,0,3.5,1.3 c0.3,0.6,0.3,1.3,0.1,1.9l-136.1,159.2l-18,32.6c-0.7,1.3-2.3,1.8-3.6,1.1c-0.5-0.3-0.9-0.7-1.1-1.1L1463.2,480.4z"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "1495.8,536.8 1525.7,512.2 1514.3,503.5  "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FBFBFB",
    cx: 984.8,
    cy: 1185,
    r: 7.5
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M969.6,491.3c-4.8-2.8-4.8-7.2,0-10l67.1-38.7c4.8-2.8,12.6-2.8,17.3,0l67.1,38.7c4.8,2.8,4.8,7.2,0,10 L1054,530c-4.8,2.8-12.6,2.8-17.3,0L969.6,491.3z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "#43FFBB",
    enableBackground: "new    ",
    d: "M1127,486.3c-0.1-1.2-0.8-2.2-1.9-2.7l-75-43.3 c-2.9-1.5-6.4-1.5-9.4,0l-75,43.3c-1.1,0.5-1.8,1.5-1.9,2.7v-16.2c0.1-1.2,0.9-2.2,1.9-2.7l75-43.3c3-1.5,6.4-1.5,9.4,0l75,43.3 c1.1,0.5,1.8,1.5,1.9,2.7V486.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 963.69,
    y1: 1417.6312,
    x2: 1126.9301,
    y2: 1417.6312,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M963.7,621.3c0.1,1.2,0.9,2.2,1.9,2.7l75,43.3c2.9,1.5,6.4,1.5,9.4,0l75-43.3 c1.1-0.5,1.8-1.5,1.9-2.7v-125c-0.1,1.2-0.8,2.2-1.9,2.7l-75,43.3c-2.9,1.5-6.4,1.5-9.4,0l-75-43.3c-1.1-0.5-1.8-1.5-1.9-2.7V621.3 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 963.6539,
    y1: 1503.6699,
    x2: 1127.0361,
    y2: 1503.6699,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M965,494l79-45.6c0.8-0.5,1.9-0.5,2.7,0l79,45.6c1.3,0.7,1.7,2.4,1,3.7c-0.2,0.4-0.6,0.7-1,1 l-79,45.6c-0.8,0.5-1.9,0.5-2.7,0l-79-45.6c-1.3-0.7-1.7-2.4-1-3.7C964.3,494.6,964.6,494.2,965,494z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    enableBackground: "new    ",
    d: "M1068.2,564.3l11.9-6.9c0.5-0.3,1.1-0.1,1.4,0.4 c0.1,0.1,0.1,0.3,0.1,0.5v89.6c0,0.5-0.3,0.9-0.7,1.2l-12,6.9c-0.5,0.3-1.1,0.1-1.3-0.4c-0.1-0.1-0.1-0.3-0.1-0.4v-89.6 C1067.5,565,1067.7,564.6,1068.2,564.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    enableBackground: "new    ",
    d: "M1099.7,513.7l11.9-6.9c0.5-0.3,1.1-0.1,1.4,0.4 c0.1,0.1,0.1,0.3,0.1,0.5v89.6c0,0.5-0.3,0.9-0.7,1.2l-12,6.9c-0.5,0.3-1.1,0.1-1.3-0.4c-0.1-0.1-0.1-0.3-0.1-0.4v-89.6 C1099,514.3,1099.2,513.9,1099.7,513.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 963.69,
    y1: 1498.0913,
    x2: 1126.9301,
    y2: 1498.0913,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M963.7,486.4c0.1,1.2,0.9,2.2,1.9,2.7l75,43.3c2.9,1.5,6.4,1.5,9.4,0l75-43.3 c1.1-0.5,1.8-1.5,1.9-2.7v-16.2c-0.1,1.2-0.8,2.3-1.9,2.8l-75,43.3c-2.9,1.5-6.4,1.5-9.4,0l-75-43.3c-1.1-0.5-1.8-1.5-1.9-2.7 V486.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 963.6346,
    y1: 1529.7549,
    x2: 1127.0255,
    y2: 1529.7549,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M965,467.9l79-45.6c0.8-0.5,1.9-0.5,2.7,0l78.9,45.6c1.3,0.8,1.8,2.4,1,3.7c-0.2,0.4-0.6,0.8-1,1 l-78.9,45.6c-0.8,0.5-1.9,0.5-2.7,0l-79-45.6c-1.3-0.8-1.8-2.4-1-3.7C964.2,468.5,964.6,468.1,965,467.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 963.69,
    y1: 1525.3599,
    x2: 1126.9301,
    y2: 1525.3599,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "url(#SVGID_22_)",
    enableBackground: "new    ",
    d: "M963.7,459.2c0.1,1.2,0.9,2.2,1.9,2.7l75,43.3 c2.9,1.5,6.4,1.5,9.4,0l75-43.3c1.1-0.5,1.8-1.5,1.9-2.7V443c-0.1,1.2-0.8,2.2-1.9,2.7l-75,43.3c-2.9,1.5-6.4,1.5-9.4,0l-75-43.3 c-1.1-0.5-1.8-1.5-1.9-2.7V459.2z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M965.1,440.6L1044,395c0.9-0.5,1.9-0.5,2.8,0l78.8,45.5c1.3,0.8,1.8,2.5,1,3.8c-0.2,0.4-0.6,0.8-1,1 l-78.8,45.5c-0.9,0.5-1.9,0.5-2.8,0l-78.9-45.5c-1.3-0.8-1.8-2.5-1-3.8C964.3,441.2,964.7,440.8,965.1,440.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 963.69,
    y1: 1554.1213,
    x2: 1126.9301,
    y2: 1554.1213,
    gradientTransform: "matrix(1 0 0 -1 0 2000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "url(#SVGID_23_)",
    enableBackground: "new    ",
    d: "M963.7,430.4c0.1,1.2,0.9,2.2,1.9,2.7l75,43.3 c2.9,1.5,6.4,1.5,9.4,0l75-43.3c1.1-0.5,1.8-1.5,1.9-2.7v-16.2c-0.1,1.2-0.8,2.2-1.9,2.7l-75,43.3c-2.9,1.5-6.4,1.5-9.4,0l-75-43.3 c-1.1-0.5-1.8-1.5-1.9-2.7V430.4z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M964.9,411.9l79.1-45.7c0.8-0.5,1.8-0.5,2.7,0l79.1,45.7c1.3,0.7,1.7,2.4,1,3.6c-0.2,0.4-0.6,0.7-1,1 l-79.1,45.7c-0.8,0.5-1.8,0.5-2.7,0l-79.1-45.7c-1.3-0.7-1.7-2.4-1-3.6C964.2,412.5,964.5,412.1,964.9,411.9z"
  })))));
}

export default SvgIlluSmartphone;